import { render, staticRenderFns } from "./ProgramsView.vue?vue&type=template&id=030b3348"
import script from "./ProgramsView.vue?vue&type=script&lang=js"
export * from "./ProgramsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports